// React
import React from 'react';
import config from 'config';
import {connect} from 'react-redux';

// Internationalization
import * as intl from '../../translations'
import {IntlProvider, addLocaleData} from 'react-intl';
import LocaleEN from 'react-intl/locale-data/en';
import LocalePT from 'react-intl/locale-data/pt';
import LocaleES from 'react-intl/locale-data/es';

addLocaleData([...LocaleEN, ...LocalePT, ...LocaleES]);

class IntlSwapProvider extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		//let lang = this.props.intl.lang.substring(0, 2);

    // Aidionando PT-BR como locale Default para sistemas em outros idiomas.
    // Obs.: Deixar dinâmico quando houver outras lojas e arquivos de idiomas customizados.
    let lang = 'pt';

		const resolvedLang = this.props.intl.lang.replace(/-/g, '');
		const defaultLang = config.application.defaultLanguage.replace(/-/g, '');

		const messageFile = (intl[resolvedLang]) ? intl[resolvedLang] : intl[defaultLang] ;

		return (
			<IntlProvider locale={lang} messages={messageFile} location={this.props.location}>
				{this.props.children}
			</IntlProvider>
		);
	}
}

const mapStateToProps = function (store) {
	return {
		intl: store.intlState.intl,
		location: store.locationState.location,
	};
};

export default connect(mapStateToProps)(IntlSwapProvider);


// WEBPACK FOOTER //
// ./src/components/providers/intlSwapProvider.component.jsx